import { useState, useRef } from 'react';

function TodoForm({ ajouterTache }) {
  const [texte, setTexte] = useState('');
  const inputRef = useRef(null);

  const soumettreFormulaire = (e) => {
    e.preventDefault();
    const trimmed = texte.trim();
    if (trimmed === '') return;
    ajouterTache(trimmed);
    setTexte('');
    inputRef.current?.focus(); 
  };

  return (
    <form onSubmit={soumettreFormulaire}>
      <label htmlFor="nouvelle-tache">Nouvelle tâche</label>
      <input
        id="nouvelle-tache"
        ref={inputRef}
        value={texte}
        onChange={(e) => setTexte(e.target.value)}
        placeholder="Exemple : Acheter du lait"
        required
      />
      <button type="submit" disabled={!texte.trim()}>
        Ajouter
      </button>
    </form>
  );
}

export default TodoForm;